import React from 'react';
import { Outlet } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline'; 
// This is a react router Layout Route component
// Outlet inserts the matching child router
const MainLayout = () => {
  return (
    <>
      <CssBaseline />
      {/* <HeaderBar /> */}
      {/* <Header></Header> */}
      <div>
        <Outlet />
      </div>
    </>
  );
};

export default MainLayout;